import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useVirtualVenueState() {
  return useAppState();
}

export function useVirtualVenueActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        loading: true,
        meetingSession: null,
        audioVideoDevicesAreChosen: false,
        deviceChangeObserverIsSet: false,
        audioVideoObserverIsSet: false,
        attendeePresenceCallbackIsSet: false,
        meetingIsActive: false,
        tileIndex: new Array(9).fill(null),
      },
    }));
  }

  function setMeetingSession(meetingSession) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        meetingSession,
      },
    }));
  }

  function setAudioVideoDevicesAreChosen(chosen) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        audioVideoDevicesAreChosen: chosen,
      },
    }));
  }

  function setDeviceChangeObserverIsSet(set) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        deviceChangeObserverIsSet: set,
      },
    }));
  }

  function setAudioVideoObserverIsSet(set) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        audioVideoObserverIsSet: set,
      },
    }));
  }

  function setAttendeePresenceCallbackIsSet(set) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        attendeePresenceCallbackIsSet: set,
      },
    }));
  }

  function setMeetingIsActive(active) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        meetingIsActive: active,
      },
    }));
  }

  function lockTile(tileId) {
    dispatch((state) => {
      const newTileIndex = state.virtualVenue?.tileIndex?.slice() || [];
      const availableIndex = newTileIndex.indexOf(null);
      if (availableIndex !== -1) {
        newTileIndex[availableIndex] = tileId;
        return {
          ...state,
          virtualVenue: {
            ...state.virtualVenue,
            tileIndex: newTileIndex,
          },
        };
      }
      return state;
    });
  }

  function unlockTile(tileId) {
    dispatch((state) => {
      const newTileIndex = state.virtualVenue?.tileIndex?.slice() || [];
      const tileIndexToUnlock = newTileIndex.indexOf(tileId);
      if (tileIndexToUnlock !== -1) {
        newTileIndex[tileIndexToUnlock] = null;
        return {
          ...state,
          virtualVenue: {
            ...state.virtualVenue,
            tileIndex: newTileIndex,
          },
        };
      }
      return state;
    });
  }

  function onError(feedback) {
    dispatch((state) => ({
      ...state,
      virtualVenue: {
        ...state.virtualVenue,
        loading: false,
      },
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    setMeetingSession,
    setAudioVideoDevicesAreChosen,
    setDeviceChangeObserverIsSet,
    setAudioVideoObserverIsSet,
    setAttendeePresenceCallbackIsSet,
    setMeetingIsActive,
    lockTile,
    unlockTile,
    onError,
    clearFeedback,
  };
}
